import { createReducer } from '@reduxjs/toolkit';
import { getAllIndustriesAction } from './actions';

const initialState = {
  list: [],
};

export default createReducer(initialState, builder =>
  builder.addCase(getAllIndustriesAction, (state, action) => {
    state.list = action.payload;
  })
);
